<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <DebouncedSearchField v-model="searchQuery" />
      </v-col>
      <authorization
        permissionKey="configuration_facilitator_medical_request_item"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-col v-if="authorization" md="3">
          <v-dialog v-model="newFacilitatorDialog" max-width="900">
            <template v-slot:activator="{ on }">
              <v-btn color="light-blue" block dark v-on="on">
                Novo facilitador
              </v-btn>
            </template>

            <MedicalRequestItemFacilitatorForm
              @close="closeNewFacilitatorDialog"
              @refresh="refreshFacilitators"
            />
          </v-dialog>
        </v-col>
      </authorization>
    </v-row>

    <v-pagination
      v-if="totalPages > 1"
      v-model="currentPage"
      :length="totalPages"
      :total-visible="10"
      class="mb-2"
    />

    <v-row v-if="noResults" justify="center">
      <v-col cols="6">
        <v-alert color="orange" outlined text type="info">
          Nenhum facilitador encontrado.
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-else justify="center">
      <v-col cols="auto">
        <p>
          Foram encontrados <strong>{{ totalCount }} facilitadores</strong>.
        </p>
      </v-col>
    </v-row>

    <SpinnerRow
      v-if="isLoading"
      class="pt-4"
      text="Carregando facilitadores..."
    />
    <v-row
      v-else
      dense
      v-for="facilitator in facilitators"
      :key="facilitator.id"
    >
      <v-col>
        <MedicalRequestItemFacilitatorCard
          :facilitator="facilitator"
          @refresh="refreshFacilitators"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DebouncedSearchField from "@/components/ui/form/debounced_search_field.vue";
import SpinnerRow from "@/components/ui/load_status/spinner-row.vue";
import MedicalRequestItemFacilitatorCard from "@/components/config/medical_request/item_facilitators/item_facilitator_card.vue";
import MedicalRequestItemFacilitatorForm from "@/components/config/medical_request/item_facilitators/item_facilitator_form.vue";

export default {
  name: "MedicalRequestItemFacilitators",
  components: {
    DebouncedSearchField,
    SpinnerRow,
    MedicalRequestItemFacilitatorCard,
    MedicalRequestItemFacilitatorForm,
  },
  data() {
    return {
      searchQuery: null,
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      newFacilitatorDialog: false,
    };
  },
  apollo: {
    facilitators: {
      query: require("@/components/config/medical_request/item_facilitators/getMedicalRequestItemFacilitators.gql"),
      variables() {
        return {
          page: this.currentPage,
          limit: 25,
          searchQuery: this.searchQuery || null,
        };
      },
      update({ medicalRequestItemFacilitators }) {
        this.currentPage = medicalRequestItemFacilitators.metadata.currentPage;
        this.totalPages = medicalRequestItemFacilitators.metadata.totalPages;
        this.totalCount = medicalRequestItemFacilitators.metadata.totalCount;

        if (this.currentPage > this.totalPages) {
          this.currentPage = 1;
        }

        return medicalRequestItemFacilitators.collection;
      },
    },
  },
  computed: {
    isLoading() {
      return this.$apollo.queries.facilitators.loading;
    },
    noResults() {
      return this.facilitators?.length == 0;
    },
  },
  methods: {
    closeNewFacilitatorDialog() {
      this.newFacilitatorDialog = false;
    },
    async refreshFacilitators() {
      await this.$apollo.queries.facilitators.refetch();
    },
  },
};
</script>

<style scoped></style>
